<div class="code-input-container">
  <mat-form-field appearance="outline" [ngClass]="{ 'error-custom': code && code.length < 6 }">
    <mat-label>{{ "registration.mfa.input-label" | translate }}</mat-label>
    <input
      matInput
      type="text"
      required
      (input)="filterDigits($event)"
      (keydown.enter)="onClick()"
      [maxLength]="6"
      [minLength]="6"
      placeholder="******"
      pattern="\d*" />
  </mat-form-field>
  <button [disabled]="code.length < 6" class="primary-button verify-button" mat-stroked-button (click)="onClick()">
    <span class="btn-label">{{ "registration.mfa.button-text" | translate }}</span>
  </button>
</div>
